import ManageProviderTable from './ManageProviderTable'

const ManageProvider = {
  Table: ManageProviderTable,
}

export default ManageProvider
